import { FIELD_TYPE_LABEL, type FieldSuggestion } from "@eduviaos/shared";

import type { SelectableNode } from "../lib/collectNodes.js";
import { DiffNodeRow } from "./DiffNodeRow.js";

/**
 * L4 — one proposed form field (Phase F-finale-4 Slice 5).
 *
 * Used both standalone in the FormBuilder (target_kind=field) and inline
 * within L1/L2 when the funnel/stage suggestion bundles new fields. Surfaces
 * the friendly field-type label plus the validation that matters most to a
 * reviewer (required, accepted MIME types, max upload size).
 */
export interface AIFormFieldDiffProps {
  field: FieldSuggestion;
  node: SelectableNode;
  checked: boolean;
  onToggle: () => void;
}

export function AIFormFieldDiff({ field, node, checked, onToggle }: AIFormFieldDiffProps) {
  const def = field.field;
  const v = def.validation;
  const meta: string[] = [];
  if (v?.required) meta.push("Required");
  if (v?.mime_types?.length) meta.push(`Accepts ${v.mime_types.join(", ")}`);
  if (v?.max_file_size_mb != null) meta.push(`Max ${v.max_file_size_mb} MB`);

  return (
    <DiffNodeRow
      node={node}
      checked={checked}
      onToggle={onToggle}
      ariaLabel={def.label}
      title={def.label}
      reason={field.reason}
      details={
        <div className="flex flex-wrap items-center gap-2">
          <code className="bg-muted text-muted-foreground rounded px-1.5 py-0.5 text-[11px]">
            {FIELD_TYPE_LABEL[def.field_type]}
          </code>
          {meta.map((m) => (
            <span key={m} className="text-muted-foreground text-[11px]">
              {m}
            </span>
          ))}
        </div>
      }
    />
  );
}
